"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideViewer = undefined;

var _hyperapp = require("hyperapp");

var _Tooltip = require("./Tooltip");

var _getMagnitudeFromRange = require("./getMagnitudeFromRange");

var _QiitaLogo = require("./QiitaLogo");

var LEFT_KEY = 37;
var RIGHT_KEY = 39;

var SlideViewer = exports.SlideViewer = function SlideViewer(_ref) {
  var state = _ref.state,
      actions = _ref.actions,
      pages = _ref.pages,
      _ref$option = _ref.option,
      option = _ref$option === undefined ? {} : _ref$option;
  var theme = option.theme,
      contentClass = option.contentClass;

  var next = function next() {
    return actions.next(pages.length);
  };
  var prev = actions.prev;

  return (0, _hyperapp.h)(
    "div",
    {
      "class": "slideMode" + (state.isFullScreen ? " fullscreen" : ""),
      oncreate: function oncreate(element) {
        element.customKeyHandler = function (event) {
          if (event.keyCode === LEFT_KEY) {
            prev();
          } else if (event.keyCode === RIGHT_KEY) {
            next();
          }
        };
        addEventListener("keydown", element.customKeyHandler);
      },
      ondestroy: function ondestroy(element) {
        removeEventListener("keydown", element.customKeyHandler);
      }
    },
    (0, _hyperapp.h)(
      "div",
      { "class": "slideMode-Viewer" },
      (0, _hyperapp.h)("div", {
        "class": "slideMode-Viewer_content" + (state.page === 0 ? " slideMode-Viewer_content--firstSlide" : "") + (contentClass ? " " + contentClass : " markdownContent"),
        onclick: function onclick(event) {
          if (event.target.tagName === "IMG" || event.target.tagName === "A") {
            return;
          }

          // We want to use getBoundingClientRect because it always returns
          // the actual rendered element dimensions, even if there are CSS
          // transformations applied to it.
          var rect = event.currentTarget.getBoundingClientRect();

          // Should we transition to the next or the previous slide?
          if (event.clientX - rect.left > rect.width / 2) {
            next();
          } else {
            prev();
          }
        },
        innerHTML: pages[state.page]
      })
    ),
    (0, _hyperapp.h)(_Tooltip.Tooltip, { state: state.tooltip, length: pages.length }),
    (0, _hyperapp.h)(
      "div",
      {
        "class": "slideMode-Dashboard" + (theme ? " slideMode-Dashboard-" + theme : "")
      },
      (0, _hyperapp.h)(
        "button",
        {
          "class": "slideMode-Dashboard_button slideMode-Dashboard_button--prev " + (theme ? " slideMode-Dashboard_button-" + theme : "") + (state.page !== 0 ? " slideMode-Dashboard_button--clickable" : ""),
          disabled: state.page === 0,
          onclick: actions.prev
        },
        (0, _hyperapp.h)("i", { "class": "fa fa-backward" })
      ),
      (0, _hyperapp.h)(
        "button",
        {
          "class": "slideMode-Dashboard_button slideMode-Dashboard_button--next " + (theme ? " slideMode-Dashboard_button-" + theme : "") + (state.page !== pages.length - 1 ? " slideMode-Dashboard_button--clickable" : ""),
          disabled: state.page === pages.length - 1,
          onclick: function onclick() {
            return actions.next(pages.length);
          }
        },
        (0, _hyperapp.h)("i", { "class": "fa fa-forward" })
      ),
      (0, _hyperapp.h)(
        "span",
        { "class": "slideMode-Dashboard_pageCount" },
        state.page + 1,
        " / ",
        pages.length
      ),
      (0, _hyperapp.h)(
        "div",
        {
          "class": "slideMode-Dashboard_progress" + (theme ? " slideMode-Dashboard_progress-" + theme : ""),
          onmousemove: function onmousemove(event) {
            actions.tooltip.show({
              page: (0, _getMagnitudeFromRange.getMagnitudeFromRange)(event.currentTarget, event.clientX, pages.length),
              left: event.clientX - event.currentTarget.getBoundingClientRect().left
            });
          },
          onmouseleave: function onmouseleave(event) {
            actions.tooltip.hide();
          },
          onclick: function onclick(event) {
            actions.goto((0, _getMagnitudeFromRange.getMagnitudeFromRange)(event.currentTarget, event.clientX, pages.length) - 1);
          }
        },
        (0, _hyperapp.h)("div", {
          "class": "slideMode-Dashboard_progressFill" + (theme ? " slideMode-Dashboard_progressFill-" + theme : ""),
          style: {
            width: (state.page + 1) / pages.length * 100 + "%"
          }
        })
      ),
      (0, _hyperapp.h)(
        "button",
        {
          "class": "slideMode-Dashboard_button slideMode-Dashboard_button--fullscreen slideMode-Dashboard_button--clickable" + (theme ? " slideMode-Dashboard_button-" + theme : ""),
          onclick: actions.toggleFullScreen
        },
        (0, _hyperapp.h)("i", { "class": "fa fa-desktop" })
      ),
      (0, _hyperapp.h)(_QiitaLogo.QiitaLogo, null)
    )
  );
};